import { createHeaders, mapResponseToJson } from '@atlassiansox/asc-core';
import { fetch } from 'cross-fetch';

import {
  CloudSignUpRequest,
  CloudSignUpResponse
} from './bxp-express-client.types';

export type BXPExpressStargateClientOptions = {
  readonly baseUrl?: string;
};

export class BXPExpressStargateClient {
  public static DEFAULT_BASE_URL =
    'https://wac.stg.internal.atlassian.com/gateway/api';

  private readonly baseUrl: string;

  public constructor({
    baseUrl = BXPExpressStargateClient.DEFAULT_BASE_URL
  }: BXPExpressStargateClientOptions = {}) {
    this.baseUrl = baseUrl;
  }

  public async cloudSignup({
    payload,
    cookies
  }: CloudSignUpRequest): Promise<CloudSignUpResponse> {
    return mapResponseToJson(
      await fetch(`${this.baseUrl}/cloud/signup`, {
        method: 'POST',
        headers: createHeaders({
          'Content-Type': 'application/json',
          'ATL-Cookies': JSON.stringify(cookies)
        }),
        body: JSON.stringify(payload),
        credentials: 'include'
      })
    );
  }
}
